import React from 'react';

// Booked/Not booked status pill (prototype .stt — revised 2026-08-24): a
// STATUS DISPLAY, not a toggle. Booked = green with a filled ✓ checkbox;
// Not booked = plain amber tag with NO checkbox (an empty checkbox next to
// "Not booked" read as "check to opt into not-booked" — Paulo). Tapping never
// flips the status: `onPress` (cards → open the sheet; leg sheet → expand the
// ticket section) navigates to where the real control lives, a Switch inside
// the section. Without `onPress` it renders as a plain tag (stop sheet, where
// the section is already visible). Vocabulary: "Booked"/"Not booked" (Paulo
// 2026-08-24, superseding "Planned/Unplanned" — three testers couldn't guess
// what "Planned" meant); code identifiers deliberately stay `planned`.
// Distinct from StatusPill (the trip lifecycle pill). See
// docs/codebase/ui-conventions.md → Status pills.

const pillStyle = (planned: boolean, disabled?: boolean): React.CSSProperties => ({
  display: 'inline-flex', alignItems: 'center', gap: 6, border: 'none',
  fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 999,
  opacity: disabled ? 0.5 : 1, flexShrink: 0,
  color: planned ? '#127a54' : '#9c7b22', background: planned ? '#e3efe9' : '#f7eed4',
});

const CheckGlyph: React.FC = () => (
  <span
    aria-hidden
    style={{
      width: 13, height: 13, borderRadius: 4, boxSizing: 'border-box', flex: 'none',
      display: 'inline-grid', placeItems: 'center', fontSize: 10, fontWeight: 900, lineHeight: 1,
      border: '1.6px solid #127a54', background: '#127a54', color: '#fff',
    }}
  >
    ✓
  </span>
);

const PlannedPill: React.FC<{ planned: boolean; disabled?: boolean; onPress?: () => void }> = ({ planned, disabled, onPress }) => {
  const label = planned ? 'Booked' : 'Not booked';
  if (!onPress) {
    return (
      <span className="rt-stt" aria-label={label} style={pillStyle(planned, disabled)}>
        {planned && <CheckGlyph />}
        {label}
      </span>
    );
  }
  return (
    <button
      type="button"
      className="rt-stt"
      aria-label={`${label}. Tap to see the details`}
      disabled={disabled}
      onClick={onPress}
      style={{ ...pillStyle(planned, disabled), cursor: disabled ? 'default' : 'pointer' }}
    >
      {planned && <CheckGlyph />}
      {label}
    </button>
  );
};

export default PlannedPill;
